// extracted by mini-css-extract-plugin
export default {"summary__total-cell":"summary__total-cell--tPDd7","summaryTotalCell":"summary__total-cell--tPDd7"};